module.exports = __webpack_public_path__ + "img/u-p-fill.c7c72c5e.svg";